import type { VCFormValues } from "./types";

export const VC_FORM_DEFAULTS: VCFormValues = {
  name: "",
  email: "",
  fundName: "",
  fundWebsite: "",
  location: "",
  consent: false,
};

export const fieldConfig = {
  name: {
    name: "name" as const,
    required: true,
  },
  email: {
    name: "email" as const,
    required: true,
  },
  fundName: {
    name: "fundName" as const,
    required: true,
  },
  fundWebsite: {
    name: "fundWebsite" as const,
    required: true,
  },
  location: {
    name: "location" as const,
    required: true,
  },
  consent: {
    name: "consent" as const,
    required: true,
  },
};
